module.exports = __webpack_public_path__ + "catalog/items/firesafety/direction-diagonal-top-left/direction-diagonal-top-left.svg";